export enum SubNavEnum {
    NONE,
    GENERIC,
    PROJECTS,
    COLLECTORS,
    CUSTOMERS
}